import { motion } from "framer-motion";
import { Radio, Award } from "lucide-react";
import { LABELS, RADIO_RESIDENCY } from "@/lib/constants";
import { fadeUp, stagger, viewportOnce } from "@/lib/motion";

export const Labels = () => {
  return (
    <section
      id="official"
      data-testid="labels-section"
      className="relative w-full bg-bg py-16 md:py-24 border-t border-[color:var(--line)]"
    >
      <div className="mx-auto max-w-[1500px] px-6 md:px-10">
        <motion.div
          variants={stagger(0.1, 0.05)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="flex flex-col md:flex-row md:items-end md:justify-between gap-8 mb-10 md:mb-14"
        >
          <motion.div variants={fadeUp}>
            <p className="mb-3 inline-flex items-center gap-3 text-[10px] font-semibold tracking-[0.32em] uppercase text-gold">
              <span className="h-px w-8 bg-[color:var(--gold)]/70" />
              Chapter 01
            </p>
            <h2
              data-testid="labels-title"
              className="font-display text-3xl md:text-4xl lg:text-5xl font-bold tracking-tight text-ink"
            >
              Official <span className="font-editorial text-gold-hi">releases</span>
            </h2>
          </motion.div>
          <motion.p
            variants={fadeUp}
            className="max-w-md text-sm text-muted leading-relaxed"
          >
            Signed by internationally recognized electronic music labels.
            Trusted globally.
          </motion.p>
        </motion.div>

        {/* Label plaques */}
        <motion.div
          variants={stagger(0.12, 0.1)}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-6"
        >
          {LABELS.map((l, i) => (
            <motion.div
              key={l.name}
              variants={fadeUp}
              data-testid={`label-card-${i}`}
              className="group relative flex items-center justify-between rounded-sm border border-[color:var(--line)] bg-bg-2 px-6 py-6 transition-all duration-500 hover:border-[color:var(--gold)]/60 hover:bg-[color:var(--gold)]/[0.04]"
            >
              <div className="flex items-center gap-4">
                <span className="flex h-9 w-9 items-center justify-center rounded-full border border-[color:var(--gold)]/40 text-gold transition-all duration-500 group-hover:border-[color:var(--gold)] group-hover:bg-[color:var(--gold)] group-hover:text-[#0a0a0a]">
                  <Award size={14} />
                </span>
                <div>
                  <p className="font-display text-base md:text-lg font-semibold uppercase tracking-[0.14em] text-ink">
                    {l.name}
                  </p>
                  <p className="text-[10px] font-semibold uppercase tracking-[0.28em] text-muted">
                    {l.sub}
                  </p>
                </div>
              </div>
              <span className="font-editorial text-2xl text-[color:var(--gold-hi)]/70">
                0{i + 1}
              </span>
            </motion.div>
          ))}
        </motion.div>

        {/* Radio residency */}
        <motion.div
          variants={fadeUp}
          initial="hidden"
          whileInView="visible"
          viewport={viewportOnce}
          data-testid="radio-residency"
          className="mt-6 flex flex-col md:flex-row md:items-center md:justify-between gap-4 rounded-sm border border-[color:var(--gold)]/30 bg-gradient-to-r from-[color:var(--gold)]/[0.06] to-transparent px-6 py-6"
        >
          <div className="flex items-center gap-4">
            <span className="flex h-9 w-9 items-center justify-center rounded-full bg-[color:var(--gold)] text-[#0a0a0a]">
              <Radio size={14} />
            </span>
            <div>
              <p className="text-[10px] font-semibold uppercase tracking-[0.32em] text-gold">
                {RADIO_RESIDENCY.role}
              </p>
              <p className="font-display text-base md:text-lg font-semibold uppercase tracking-[0.14em] text-ink">
                {RADIO_RESIDENCY.name}
              </p>
            </div>
          </div>
          <p className="text-xs md:text-sm text-muted font-editorial text-lg">
            Broadcasting to listeners around the world.
          </p>
        </motion.div>
      </div>
    </section>
  );
};
